


















































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import states from '@assets/states.json'
import dmas from '@assets/dma.json'
import cities from '@assets/cities.json'
import Selector from '@ui/Inputs/Selector'
import TagBar from '@ui/TagBar'
import sort from  '@utils/sort.coffee'

settings =
  name: "LocationSelector"

  vue:
    props: ['selectedLocationKeys', 'theme', 'actions']
    components: { Selector, TagBar }

    computed:
      locations: ->
        options = []

        for key, value of states
          type = 'US State'
          sortBy = "0 #{key} #{value}"
          options.push { key, value, type, sortBy }

        for key, v of dmas
          type = 'DMA'
          value = @$options.filters.formatDMA(v)
          sortBy = "1 #{key} #{value}"
          options.push { key, value, type, sortBy }

        for key, value of cities
          type = 'City'

          city = value.split(', ')[0]
          abv = ''
          (abv += word.charAt(0)) for word in city.split(' ')

          sortBy = "2 #{abv} #{key} #{value}"
          options.push { key, value, type, sortBy }

        options.sort((a, b) ->
          return if a.value > b.value then 1 else -1
        )

      selectedLocations: ->
        { state_list, dma_list, city_list } = @selectedLocationKeys
        list = [...(state_list || []), ...(dma_list || []), ...(city_list || [])]
        @locations.filter((location) -> list.includes(location.key))

      selectedKeys: -> @selectedLocations.map((location) -> location.key)

      selectedLocationsForTags: ->
        @selectedLocations.map((option) ->
          { key, value, type } = option
          icon = { name: type }
          { key, value, type, icon }
        )

      selectedStatesForTags: -> @selectedLocationsForTags.filter((option) -> option.type is 'US State').reverse()
      selectedDMAForTags: -> @selectedLocationsForTags.filter((option) -> option.type is 'DMA').reverse()
      selectedCitiesForTags: -> @selectedLocationsForTags.filter((option) -> option.type is 'City').reverse()

      selectorOptions: ->
        {
          searchBoxPlaceholder: 'Search by state, market (DMA) or city',
          selectOptionsTitle: false,
          searchSort: sort.matchLocationTypeSort
        }

      tagBarOptions: ->
        {
          bar: {
            theme: 'selector',
            max: 4
          },
          tag: {
            theme: 'selector',
            maxLength: 8
          }
        }

    methods:
      clearSearch: ->
        @$refs.selector.clearSearch()

export default VueOptions.vue settings
